import {
  getPlanSubscriptionStatus,
  getBusinessPlan,
  getRole,
} from '../constants/localStorageManager';
import { USERS } from '../constants/Users';
import { SURVEY_LIMITS, PLANS, PLAN_STATUS } from '../constants/plans';

export const getPlanLimitDetails = () => {
  if (isSuperAdmin() || isEssentialPlan()) return SURVEY_LIMITS.ESSENTIAL;
  const planDetails = getBusinessPlan() || {};
  const planKey = Object.keys(PLANS).find(
    key => planDetails.title === PLANS[key]
  );
  if (planKey) {
    return SURVEY_LIMITS[planKey];
  }

  return {};
};

export const checkPlanValidity = () => {
  return (
    isSuperAdmin() || ((isProPlan() || isEssentialPlan()) && isPlanActive())
  );
};

export const hasAddonsSupport = () => {
  return checkPlanValidity();
};

export const isEssentialPlan = () => {
  const planDetails = getBusinessPlan() || {};
  return planDetails.title === PLANS.ESSENTIAL;
};

export const isPlanActive = () => {
  const planSubscription = getPlanSubscriptionStatus() || {};
  return (
    planSubscription.status === PLAN_STATUS.ACTIVE || isPendingCancellation()
  );
};

export const isPendingCancellation = () => {
  const planSubscription = getPlanSubscriptionStatus() || {};
  return planSubscription.status === PLAN_STATUS.PENDING_CANCELATION;
};

export const isBasicPlan = () => {
  const planDetails = getBusinessPlan() || {};

  return planDetails.title === PLANS.BASIC && isPlanActive();
};

export const isProPlan = () => {
  const planDetails = getBusinessPlan() || {};

  return planDetails.title === PLANS.PRO && isPlanActive();
};

export const isSuperAdmin = () => {
  return getRole() === USERS.ADMIN;
};

export const canAddSurvey = currentCount => {
  if (isEssentialPlan() || isProPlan() || isSuperAdmin()) return true;
  const planDetail = getPlanLimitDetails();

  return currentCount < planDetail.SURVEY;
};

export const canAddUsers = currentCount => {
  if (isEssentialPlan() || isProPlan() || isSuperAdmin()) return true;
  const planDetail = getPlanLimitDetails();

  return currentCount < planDetail.USER_ACCOUNTS;
};

export const isReportLimited = () => {
  return !(isEssentialPlan() || isProPlan() || isSuperAdmin());
};

export const canExportEmails = () => {
  if (isEssentialPlan() || isProPlan() || isSuperAdmin()) return true;

  return false;
};



// WEBPACK FOOTER //
// ./src/utils/plansHelper.js